<div class="p-4 text-center">
  <mat-icon>label</mat-icon>
  <h1 class="block text-xl font-bold mb-2">Unlimited tags with Prefund Pro</h1>
  <p>
    You have reached the tag limit of 10 on Prefund Free. Subscribe to Prefund
    Pro to get unlimited tags and all the tag colors.
  </p>
</div>
<bottom-sheet-controls
  [submitText]="'Learn more'"
  (onSubmit)="_bottomSheetRef.dismiss(true)"
></bottom-sheet-controls>
